import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { type AccessRoleCode, isAccessRoleCode } from "Models/AccessRoleCodes";

export const useCurrentUserAccessRole = () => {
  const user = useLoggedInUser();

  return user?.accessRoleCode ?? null;
};

export const useCurrentUserRole = (): AccessRoleCode | null => {
  const role = useCurrentUserAccessRole();

  return isAccessRoleCode(role) ? role : null;
};
